import { Refresh } from '@styled-icons/fa-solid';
import PropTypes from 'prop-types';
import OverLayWrapper from '../Overlay';

const StatusRefreshButton = ({ item, setShowResubmissionModal, disabled, message = '' }) => {
  return ['SFD', 'C21', 'SDI', 'EAD', 'FFD', 'GB Export', 'IE Import', 'IE Export'].includes(
    item?.['Additional Information']
  ) ? (
    <OverLayWrapper placement="top" popoverContent={<p>{message}</p>} show={message.length}>
      <button
        type="button"
        className="invoice-delete-icon p-2 h-100"
        onClick={() => setShowResubmissionModal(item?.['Additional Information'])}
        disabled={disabled}
        title="Resubmit"
      >
        <Refresh width="1rem" height="1rem" />
      </button>
    </OverLayWrapper>
  ) : (
    <></>
  );
};

StatusRefreshButton.propTypes = {
  item: PropTypes.shape({
    'Additional Information': PropTypes.string,
  }),
  setShowResubmissionModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  message: PropTypes.string,
};

export default StatusRefreshButton;
